import React from 'react'
import PropTypes from 'prop-types'
import { Navigate, useLocation } from 'react-router-dom'
import { getToken, isAdmin, clearSession } from '../services/auth/auth.helpers'

// Route guard: only authenticated users with the ADMIN role may render the
// children. Everyone else is redirected to the login page. A stale/non-admin
// session is cleared so the user is forced to authenticate again.
const RequireAdmin = ({ children }) => {
  const location = useLocation()

  if (!getToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (!isAdmin()) {
    clearSession()
    return <Navigate to="/login" replace state={{ from: location, denied: true }} />
  }

  return children
}

RequireAdmin.propTypes = {
  children: PropTypes.node,
}

export default RequireAdmin
